export default "__VITE_ASSET__c7rkp_D___"